<template>
  <div class="annotation">
    <Aheader :realIndex="2"></Aheader>
    <div class="banner">
      <div>
        <p>
          Allows users to investigate and download annotation data from NR, NT,
          COG/KOG, GO, KEGG, and Swiss-Prot databases.
        </p>
      </div>
    </div>
    <div
      class="content"
      v-loading="loading"
      element-loading-text="Data downloading"
      element-loading-spinner="el-icon-loading"
    >
      <div class="search-box">
        <input
          v-model="input"
          placeholder="Please enter"
          type="text"
          @keyup.enter="http()"
        />
        <img src="../assets/img/home-search.png" alt="search" @click="http()" />
      </div>
      <el-table :data="tableData" style="width: 100%" max-height="626">
        <el-table-column fixed prop="strainName" label="Species" width="300">
          <template slot-scope="scope">
            <!-- <i>{{ scope.row.strainName }}</i> -->
            <span style="font-style: italic;">{{ scope.row.italicName }}</span
            ><span>{{ scope.row.notItalicName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="serialCode" label="Database ID" width="150">
        </el-table-column>
        <el-table-column prop="genomeSequence" label="Genomic" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.genomeSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.genomeSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="gdsSequence" label="CDS" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.gdsSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.gdsSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="gdsSequence" label="Gene Family" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.gdsSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.gdsSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="proteinSequence" label="Protein" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.proteinSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.proteinSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="cogKogSequence" label="COG/KOG" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.cogKogSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.cogKogSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="goSequence" label="GO" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.goSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.goSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="keggSequence" label="KEGG" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
              ><img
                v-if="scope.row.keggSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.keggSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="nrSequence" label="NR" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.nrSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.nrSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="ntSequence" label="NT" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.ntSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.ntSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="swSequence" label="Swiss-Prot" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Download"
              placement="top"
            >
              <img
                v-if="scope.row.swSequence !== null"
                src="../assets/img/annotation-check.png"
                alt="Check"
                @click="getFileOutputStreamById(scope.row.swSequence,scope.row.strainName)"
                style="cursor: pointer;"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="ALL" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">
              <span style="font-weight: bold;">Download</span></el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page.sync="page"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          layout="sizes,prev, pager, next, total"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <Afooter></Afooter>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import http from '../utils/http'
import api from '../utils/api'
import Aheader from '../components/aheader.vue'
import Afooter from '../components/afooter.vue'
export default {
  name: 'Annotation',
  components: {
    Aheader,
    Afooter
  },
  data () {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      value: '10',
      loading: false,
      input: ''
    }
  },
  created () {
    if (this.$route.params.speciesName) {
      this.input = this.$route.params.speciesName
    } else {
      this.input = ''
    }
    this.$store.commit('toTop')
    this.http()
  },
  methods: {
    http () {
      // 获取数据
      http.get(
        `/annotationList?currentPage=${this.page}&pageSize=${this.pageSize}&name=${this.input}`,
        {},
        res => {
          if (res.code === 200) {
            this.tableData = res.data.records
            this.total = res.data.total
            this.tableData.forEach(ele => {
              let obj = this.$utils.getItalic(ele.strainName)
              ele.italicName = obj.italicName
              ele.notItalicName = obj.notItalicName
            })
            // this.page = res.data.current
            this.pageSize = res.data.size
          } else {
            Message.error(`${res.msg}`)
          }
        }
      )
    },
    async handleClick (row) {
      let list = []
      /* eslint-disable */
      row.genomeSequence !== null ? list.push(row.genomeSequence) : null
      row.gdsSequence !== null ? list.push(row.gdsSequence) : null
      row.proteinSequence !== null ? list.push(row.proteinSequence) : null
      row.cogKogSequence !== null ? list.push(row.cogKogSequence) : null
      row.goSequence !== null ? list.push(row.goSequence) : null
      row.keggSequence !== null ? list.push(row.keggSequence) : null
      row.nrSequence !== null ? list.push(row.nrSequence) : null
      row.ntSequence !== null ? list.push(row.ntSequence) : null
      row.swSequence !== null ? list.push(row.swSequence) : null
      /* eslint-disable */
      if (list.length === 0) {
        Message('The strain has no documentation')
      } else {
        let res = await api.getSetCheckLogin()
        if(res === '' || (res.data && res.data.code === 200)){
          this.loading = true
          http.postGetZip('/storage/downloadZipByFileId', list, res => {
            let blob = new Blob([res], {
              type: 'application/zip'
            })
            let url = window.URL.createObjectURL(blob)
            // let element = document.createElement('a')
            // element.setAttribute('href', url)
            // element.setAttribute('download', row.strainName + '.zip')
            // element.style.display = 'none'
            // element.click()
            window.location.href = url
            this.loading = false
          })
        }else{
          Message.error('not logged in')
        }
      }
    },
    handleCurrentChange(val) {
      this.http()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.http()
    },
    async getFileOutputStreamById(val,strainName) {
      let res = await api.getSetCheckLogin()
      if(res === '' || (res.data && res.data.code === 200)){
        api.queryFileInfoById(val).then(res => {
          if (res.data.code === 200) {
            if (res.data.data) {
              // let element = document.createElement('a')
              // element.setAttribute('href', `/storage/getFileOutputStreamById?fileId=${val}`)
              // // element.setAttribute('download', strainName + '.zip')
              // element.style.display = 'none'
              // element.click()
              window.location.href = `/storage/getFileOutputStreamById?fileId=${val}`
            } else {
              Message.error('File not found')
            }
          } else {
            Message.error(`${res.msg}`)
          }
        })
      }else{
        Message.error('not logged in')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.annotation {
  box-sizing: border-box;
  min-width: vw(1200);
}
.banner {
  margin-top: vw(81);
  min-width: vw(1200);
  height: vw(356);
  background-image: url('../assets/img/annotation-banner.png');
  background-size: 100% 100%;
  padding-top: vw(130);
  box-sizing: border-box;
  div {
    width: vw(1200);
    margin: 0 auto;
    p {
      width: vw(823);
      font-size: vw(24);
      color: #333;
    }
  }
}
.content {
  width: vw(1200);
  margin: 0 auto vw(250);

  .search-box {
    margin: vw(30) 0;
    position: relative;
    text-align: right;
    input {
      height: vw(40);
      width: vw(350);
      border: none;
      outline: none;
      background: #ffffff;
      border-radius: 8px;
      color: #999999;
      font-size: vw(16);
      padding-left: vw(19);
      border: 1px solid #999;
      box-sizing: border-box;

      &:hover,
      &:focus {
        border-color: $theme_color;
      }
    }
    img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: vw(15);
      cursor: pointer;
      width: vw(20);
      height: vw(20);
    }
  }

  >>> thead {
    .el-table__cell {
      .cell {
        color: #333;
      }
    }
  }

  .pagination {
    margin-top: vw(10);
    color: #666;
    font-size: vw(14);

    .el-pagination {
      display: flex;
      align-items: center;

      >>> .el-pagination__sizes {
        .el-input .el-input__inner:hover,
        .el-input .el-input__inner:focus {
          border-color: $theme_color;
        }
      }
      >>> .el-pager {
        li:hover {
          color: $theme_color;
        }
        .active {
          color: $theme_color;
        }
      }
      >>> button {
        &:hover {
          color: $theme_color;
        }
        &:disabled:hover {
          color: #c0c4cc;
        }
      }
      >>> .btn-prev {
        // flex: 1;
        // text-align: right;
        margin-left: auto;
      }
      >>> .btn-next {
        margin-right: vw(10);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/annotation.vue